/* eslint-disable max-len */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import * as actions from "../../actions";
import Drawer from "../Drawer/Drawer";
import { DiagnosticsPathMapping } from "./../../constants/index";
import { getDisplayDay, getFormattedSlotTime } from "../../utils/dateUtil";
import SelectSlot from "../PathlabSlots/SelectSlot";
import calenderIcon from "./../../images/calenderIcon.svg";
import "./ChangeLab.scss";

class ChangeLab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slotDates: [],
      firstDaySlotTimes: [],
      isFirstAvailableSlotError: false,
      isSlotDataLoading: false,
      openSlotDrawer: false,
    };
  }

  componentDidMount() {
    const { selectedLab } = this.props;
    const { is_active: isSelectedLabServiceable } = selectedLab || {};
    if (isSelectedLabServiceable) {
      this.fetchSlotData();
    }
  }

  componentDidUpdate(prevProps) {
    const { urlPathName, selectedLab } = this.props;
    const { is_active: isSelectedLabServiceable } = selectedLab || {};
    if (
      prevProps.urlPathName !== urlPathName &&
      isSelectedLabServiceable &&
      this.shouldShowNextAvailableSlot(this.props.urlPathName)
    ) {
      this.fetchSlotData();
    }
  }

  fetchSlotData = () => {
    const { selectedLab, cityAttributes, selectedPincode } = this.props;
    const { mce_id: mceId, item_id: labId } = selectedLab || {};
    const { id } = cityAttributes || {};
    const params = {
      mce_id: mceId,
      lab_id: labId,
      address_pincode: selectedPincode,
      patient_quantity: 1,
    };

    this.setState({
      isSlotDataLoading: true,
    });
    this.props.actions
      .getDiagosticsSlotDate(id, params)
      .then((resp) => {
        const { data, status } = resp || {};

        let respDates = [];
        let respFirstDaySlots = [];
        let isError = null;

        if (status === 1 && !isEmpty(data)) {
          respDates = data.dates || [];
          respFirstDaySlots = data.first_date || [];
          isError = !(respDates.length > 0 && respFirstDaySlots.length > 0);
        } else {
          respDates = [];
          respFirstDaySlots = [];
          isError = true;
        }

        this.setState({
          slotDates: respDates,
          firstDaySlotTimes: respFirstDaySlots,
          isFirstAvailableSlotError: isError,
          isSlotDataLoading: false,
        });
      })
      .catch(() => {
        this.setState({
          slotDates: [],
          firstDaySlotTimes: [],
          isFirstAvailableSlotError: true,
          isSlotDataLoading: false,
        });
      });
  };

  shouldShowNextAvailableSlot = (path) => {
    switch (path) {
      case DiagnosticsPathMapping.step2_Path:
        return true;
      case DiagnosticsPathMapping.step3_Path:
        return false;
      case DiagnosticsPathMapping.step4_Path:
        return false;
      default:
        return false;
    }
  };

  toggleSlotDrawer = () => {
    this.setState({
      openSlotDrawer: !this.state.openSlotDrawer,
    });
  };

  closeSlotDrawer = () => {
    this.toggleSlotDrawer();
    this.props.actions.resetSlotState();
  };

  render() {
    const {
      selectedLab,
      urlPathName,
      cityAttributes,
      selectedPincode,
      selectedPatient,
    } = this.props;
    const {
      openSlotDrawer,
      slotDates,
      firstDaySlotTimes,
      isFirstAvailableSlotError,
      isSlotDataLoading,
    } = this.state;
    const { is_active: isSelectedLabServiceable } = selectedLab || {};
    const { id } = cityAttributes || {};
    const nextAvailableSlotDate =
      !isSlotDataLoading &&
      !isFirstAvailableSlotError &&
      getDisplayDay(slotDates[0]);
    const nextAvailableSlotTime =
      !isSlotDataLoading &&
      !isFirstAvailableSlotError &&
      getFormattedSlotTime(firstDaySlotTimes[0]);
    const isShowNextAvailableSlotCTA =
      isSelectedLabServiceable && this.shouldShowNextAvailableSlot(urlPathName);
    return (
      <div className="ChangeLabContainer">
        <div className="flex">
          <div className="labImgContainer">
            <img src={selectedLab.item_logo} alt="lab name" />
          </div>
          <div className="labTextContainer">
            <div className="labName">{selectedLab.item_name}</div>
            <div className="labLoc">
              <img src={require("../../images/location.svg")} alt="x" />
              {selectedLab.neighbourhood}
            </div>
          </div>
        </div>
        {isShowNextAvailableSlotCTA && (
          <div
            className="nextAvailableSlotContainer"
            onClick={this.toggleSlotDrawer}
          >
            {isSlotDataLoading ? (
              <span>Next slot:&nbsp;Loading...</span>
            ) : (
              <span className="bold">
                {nextAvailableSlotTime && nextAvailableSlotDate ? (
                  `Next slot: ${nextAvailableSlotTime}, ${nextAvailableSlotDate}`
                ) : (
                  <span>
                    <img className="genderRadioBtn" alt="" src={calenderIcon} />
                    &nbsp;Check Slot Availability
                  </span>
                )}
              </span>
            )}
          </div>
        )}
        <Drawer open={openSlotDrawer} onClose={this.closeSlotDrawer}>
          <SelectSlot
            showDoneCTA={false}
            showSlotRadioBtn={false}
            selectedPincode={selectedPincode}
            selectedCityID={id}
            appointmentDateText={"Appointment Date"}
            appointmentSlotsText={"Appointment Time"}
            doneClick={() => {}}
            checkValidationOnSameOrder={() => {}}
            selectedPatient={selectedPatient}
          />
        </Drawer>
      </div>
    );
  }
}

ChangeLab.propTypes = {
  selectedLab: PropTypes.object,
  actions: PropTypes.object,
  urlPathName: PropTypes.string,
  selectedPincode: PropTypes.number,
  cityAttributes: PropTypes.object,
};

ChangeLab.defaultProps = {
  selectedLab: {},
  actions: {},
  urlPathName: "",
  selectedPincode: null,
  cityAttributes: {},
};

export default connect(
  (state) => ({
    selectedLab: state.diagnosticsCart.selectedLab,
    selectedPincode: state.customer.selectedPincode,
    cityAttributes: state.customer.cityAttributes,
    selectedPatient: state.patients.selectedPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(ChangeLab);
